require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./flexlayout"), require("./tooltip"), require("./numberinput"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./flexlayout", "./tooltip", "./numberinput"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./flexlayout"), require("./tooltip"), require("./numberinput")) : factory(root["./utils"], root["./flexlayout"], root["./tooltip"], root["./numberinput"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__50__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[57],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _tooltip = __webpack_require__(21);

var _Slider = _interopRequireDefault(__webpack_require__(35));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var TooltipWrapper = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TooltipWrapper, _Component);

  function TooltipWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      top: 0,
      left: 0,
      width: 0,
      hover: false,
      touch: false,
      dragging: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseEnter", function () {
      _this._resetStates();

      _this.setState({
        hover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseLeave", function () {
      _this.setState({
        hover: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseDown", function () {
      _this._resetStates();

      _this.setState({
        dragging: true
      });

      window.addEventListener('mouseup', _this._onMouseUp);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchStart", function () {
      _this.setState({
        touch: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTouchEnd", function () {
      _this.setState({
        touch: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseUp", function () {
      _this.setState({
        dragging: false
      });
    });
    return _this;
  }

  var _proto = TooltipWrapper.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._resetStates();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    this._resetStates();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('mouseup', this._onMouseUp);
  };

  _proto._resetStates = function _resetStates() {
    this.setState({
      top: _utils.domUtils.computeTopWith(this._containerRef),
      left: _utils.domUtils.computeLeftWith(this._containerRef),
      width: _utils.domUtils.computeWidthOf(this._containerRef)
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        orient = _this$props.orient,
        title = _this$props.title,
        showTooltip = _this$props.showTooltip,
        children = _this$props.children,
        style = _this$props.style;
    var _this$state = this.state,
        hover = _this$state.hover,
        dragging = _this$state.dragging,
        touch = _this$state.touch;
    var containerProps = {
      className: (0, _utils.classnames)(sliderClassName + "__tooltip__wrapper", "" + className),
      ref: function ref(node) {
        _this2._containerRef = node;
      },
      onMouseDownCapture: this._onMouseDown,
      onTouchStartCapture: this._onTouchStart,
      onTouchEndCapture: this._onTouchEnd,
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      style: style
    };
    var tooltipProps = {
      orient: orient,
      title: title,
      triggerState: this.state
    };
    return /*#__PURE__*/_react["default"].createElement("div", containerProps, showTooltip && (hover || dragging || touch) && /*#__PURE__*/_react["default"].createElement(_tooltip.TooltipPopup, tooltipProps), children);
  };

  return TooltipWrapper;
}(_react.Component);

exports["default"] = TooltipWrapper;
(0, _defineProperty2["default"])(TooltipWrapper, "propTypes", {
  className: _propTypes["default"].string,
  orient: _propTypes["default"].string,
  title: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  showTooltip: _propTypes["default"].bool,
  style: _propTypes["default"].object
});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(491);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(489);


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Slider = _interopRequireDefault(__webpack_require__(490));

exports["default"] = _Slider["default"];
exports.Slider = _Slider["default"];

var _RangeSlider = _interopRequireDefault(__webpack_require__(492));

exports.RangeSlider = _RangeSlider["default"];

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _Slider = _interopRequireDefault(__webpack_require__(35));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var carbonContainer = _Slider["default"].carbonContainer.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Slider = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Slider, _Component);

  function Slider() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Slider.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        labelFormatter = _this$props.labelFormatter,
        formatLabel = _this$props.formatLabel,
        _onChange = _this$props.onChange,
        className = _this$props.className,
        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["labelFormatter", "formatLabel", "onChange", "className"]);
    var mappedProps = {
      formatLabel: formatLabel || labelFormatter
    };
    var passThrouProps = (0, _lodash.omit)(rest, ['showHandleLabel', 'showBoundaryLabels', 'showTooltip', 'size']);
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Slider, (0, _extends2["default"])({
      className: className + " " + sliderClassName + carbonContainer
    }, mappedProps, passThrouProps, {
      onChange: function onChange(_ref) {
        var value = _ref.value;
        return _onChange == null ? void 0 : _onChange(value);
      }
    }));
  };

  return Slider;
}(_react.Component);

exports["default"] = Slider;
(0, _defineProperty2["default"])(Slider, "propTypes", {
  /**
   * The CSS class name for the slider.
   */
  className: _propTypes["default"].string,

  /**
   * `true` to hide the number input box.
   */
  hideTextInput: _propTypes["default"].bool,

  /**
   * The ID of the `<input>`.
   */
  id: _propTypes["default"].string,

  /**
   * The callback to get notified of change in value.
   */
  onChange: _propTypes["default"].func,

  /**
   * The callback to get notified of value on handle release.
   */
  onRelease: _propTypes["default"].func,

  /**
   * The value.
   */
  value: _propTypes["default"].number.isRequired,

  /**
   * The minimum value.
   */
  min: _propTypes["default"].number.isRequired,

  /**
   * The label associated with the minimum value.
   */
  minLabel: _propTypes["default"].string,

  /**
   * The maximum value.
   */
  max: _propTypes["default"].number.isRequired,

  /**
   * The label associated with the maximum value.
   */
  maxLabel: _propTypes["default"].string,

  /**
   *  legacy toolkit prop, map to formatLabel
   */
  labelFormatter: _propTypes["default"].func,

  /**
   * The callback to format the label associated with the minimum/maximum value.
   */
  formatLabel: _propTypes["default"].func,

  /**
   * The label for the slider.
   */
  labelText: _propTypes["default"].node,

  /**
   * A value determining how much the value should increase/decrease by moving the thumb by mouse.
   */
  step: _propTypes["default"].number,

  /**
   * A value determining how much the value should increase/decrease by Shift+arrow keys,
   * which will be `(max - min) / stepMultiplier`.
   */
  stepMultiplier: _propTypes["default"].number,

  /**
   * The child nodes.
   */
  children: _propTypes["default"].node,

  /**
   * `true` to disable this slider.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The `name` attribute of the `<input>`.
   */
  name: _propTypes["default"].string,

  /**
   * The `type` attribute of the `<input>`.
   */
  inputType: _propTypes["default"].string,

  /**
   * The `ariaLabel` for the `<input>`.
   */
  ariaLabelInput: _propTypes["default"].string,

  /**
   * `true` to use the light version.
   */
  light: _propTypes["default"].bool,

  /** Toolkit Custom CSS styling */
  style: _propTypes["default"].object,
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showHandleLabel: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showBoundaryLabels: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  showTooltip: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider),
  // deprecated prop
  // eslint-disable-next-line react/no-unused-prop-types
  size: BaPropTypes.deprecatedByCarbon(_baUiCarbon.Slider)
});
(0, _defineProperty2["default"])(Slider, "defaultProps", {
  hideTextInput: true,
  className: ''
});

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-slider{display:flex;align-items:center;align-self:center;width:100%;position:relative}.ba-common-slider__carbonContainer{min-width:8rem}.ba-common-slider__container{display:inline-block;width:100%;position:relative}.ba-common-slider__container__input{width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;height:2px;vertical-align:middle;cursor:pointer;padding:0;display:inline-block}.ba-common-slider__container__input::-webkit-slider-thumb{-webkit-appearance:none;outline:none;border-radius:50%;width:18px;height:18px}.ba-common-slider__container__input::-ms-thumb{outline:none;border:none;height:18px;width:18px;border-radius:50%}.ba-common-slider__container__input::-moz-range-thumb{-moz-appearance:none;outline:none;border-radius:50%;border:none;width:18px;height:18px}.ba-common-slider__container__input.is-range{height:18px}.ba-common-slider__container__input.is-range .ba-common-slider__rail{position:absolute;width:100%;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step{position:relative;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track{position:absolute;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input{position:absolute;left:0;width:100%;height:100%}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input:focus{outline:none}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle{position:absolute;top:50%;transform:translateY(-50%)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input{cursor:pointer;cursor:-webkit-grab;cursor:grab;border-radius:50%;-ms-touch-action:pan-x;touch-action:pan-x}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input:focus{outline:none}.ba-common-slider__container__input.is-small::-webkit-slider-thumb{width:12px;height:12px}.ba-common-slider__container__input.is-small::-ms-thumb{height:12px;width:12px}.ba-common-slider__container__input.is-small::-moz-range-thumb{width:12px;height:12px}.ba-common-slider__container__input.is-small .ba-common-slider__handle__input{width:12px;height:12px}.ba-common-slider__container__input.is-small .ba-common-slider__handle__input.is-focus{box-shadow:0 0 0 2px #a8c0f3;box-shadow:0 0 0 2px var(--focus, #a8c0f3);-webkit-box-shadow:0 0 0 2px var(--focus, #a8c0f3);-moz-box-shadow:0 0 0 2px var(--focus, #a8c0f3)}.ba-common-slider__container__input.is-small .ba-common-slider__step{width:calc(100% - 12px)}.ba-common-slider__container__input.is-small .ba-common-slider__step .ba-common-slider__track{margin-left:calc(12px / 2)}.ba-common-slider__container__input.is-medium::-webkit-slider-thumb{width:18px;height:18px}.ba-common-slider__container__input.is-medium::-ms-thumb{height:18px;width:18px}.ba-common-slider__container__input.is-medium::-moz-range-thumb{width:18px;height:18px}.ba-common-slider__container__input.is-medium .ba-common-slider__handle__input{width:18px;height:18px}.ba-common-slider__container__input.is-medium .ba-common-slider__handle__input.is-focus{box-shadow:0 0 0 2px #a8c0f3;box-shadow:0 0 0 2px var(--focus, #a8c0f3);-webkit-box-shadow:0 0 0 2px var(--focus, #a8c0f3);-moz-box-shadow:0 0 0 2px var(--focus, #a8c0f3)}.ba-common-slider__container__input.is-medium .ba-common-slider__step{width:calc(100% - 18px)}.ba-common-slider__container__input.is-medium .ba-common-slider__step .ba-common-slider__track{margin-left:calc(18px / 2)}.ba-common-slider__container__input::-ms-track{height:2px;color:transparent;border:0}.ba-common-slider__container__input::-moz-range-progress{height:2px}.ba-common-slider__container__input::-moz-range-track{height:2px}.ba-common-slider__container__input::-moz-focus-outer{border:0}.ba-common-slider__container__input::-ms-tooltip{display:none}.ba-common-slider__container.is-disabled>input{cursor:not-allowed}.ba-common-slider__container .ba-common-slider__handle_label_container{margin-left:auto;margin-right:auto;margin-bottom:8px;width:91%}.ba-common-slider__container .ba-common-slider__handle_label_container.is-range{position:relative;height:18px;margin-left:9px}.ba-common-slider__container .ba-common-slider__handle_label_container .ba-common-slider__handle_label{display:inline-block;transform:translate(-50%);font-size:20px}.ba-common-slider__container .ba-common-slider__handle_label_container .ba-common-slider__handle_label.is-range{position:absolute}.ba-common-slider__container.is-boundaryLabelled{margin:0px 8px}.ba-common-slider__container.is-handleLabelled{height:52px}.ba-common-slider__preBar{position:absolute;height:2px;line-height:2px;z-index:200;border-radius:2px;padding:0px;margin:0px;pointer-events:none;top:7px}.is-handleLabelled .ba-common-slider__preBar{top:39px}.ba-common-slider__boundary_label{font-family:'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace;font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.32px;display:flex;align-self:flex-end;display:inline-block}.ba-common-slider__tooltip_trigger{height:18px;width:18px;background:transparent;position:absolute;z-index:-1}[dir='rtl'] .ba-common-slider__handle_label{transform:translate(50%) !important}.ba-common-slider__container input{background:#e0e0e0}.ba-common-slider__container input::-webkit-slider-thumb{background-color:#161616}.ba-common-slider__container input::-moz-range-thumb{background-color:#161616}.ba-common-slider__container input::-ms-thumb{background-color:#161616}.ba-common-slider__container input::-ms-track{background-color:#161616}.ba-common-slider__container input::-ms-fill-lower{background-color:#161616}.ba-common-slider__container input::-ms-fill-upper{background-color:#161616}.ba-common-slider__container input::-moz-range-track{background:#e0e0e0}.ba-common-slider__container input::-moz-range-progress{background-color:#161616}.ba-common-slider__container input::-moz-range-track{background:#e0e0e0}.ba-common-slider__container input::-ms-fill-lower{background-color:#161616}.ba-common-slider__container input::-ms-fill-upper{background:#e0e0e0}@media screen and (-ms-high-contrast: active){.ba-common-slider__container input::-ms-fill-upper{background:#fff}}.ba-common-slider__container__input.is-range .ba-common-slider__rail{background:linear-gradient(to bottom, transparent 0, transparent 8px, #e0e0e0, #e0e0e0 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__rail.is-inverted{background:linear-gradient(to bottom, transparent 0, transparent 8px, #161616, #161616 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input{background:linear-gradient(to bottom, transparent 0, transparent 8px, #161616, #161616 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__track__input.is-inverted{background:linear-gradient(to bottom, transparent 0, transparent 8px, #e0e0e0, #e0e0e0 10px, transparent 0)}.ba-common-slider__container__input.is-range .ba-common-slider__step .ba-common-slider__handle__input{background-color:#161616}.ba-common-slider__container .ba-common-slider__handle_label_container{color:#393939}.ba-common-slider__container.is-focus{box-shadow:0 0 0 2px #a8c0f3;-webkit-box-shadow:0 0 0 2px #a8c0f3;-moz-box-shadow:0 0 0 2px #a8c0f3}.ba-common-slider__container.is-disabled{opacity:0.5}@media screen and (-ms-high-contrast: active){.ba-common-slider__container.is-disabled input::-ms-fill-lower{background:#fff}}.ba-common-slider__preBar{background-color:#0f62fe}@supports (-ms-ime-align: auto){.ba-common-slider input{height:20px}.ba-common-slider input{background:transparent}}@media all and (-ms-high-contrast: none), (-ms-high-contrast: active){.ba-common-slider input{height:20px}.ba-common-slider input{background:transparent}}\n", ""]);

// exports
exports.locals = {
	"sliderClassName": "\"ba-common-slider\"",
	"rangeSliderFlag": "\"is-range\"",
	"carbonContainer": "\"__carbonContainer\"",
	"primaryColor": "#161616",
	"neutralLightColor": "#e0e0e0"
};

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _numberinput = _interopRequireDefault(__webpack_require__(50));

var _flexlayout = _interopRequireWildcard(__webpack_require__(16));

var _Range = _interopRequireDefault(__webpack_require__(493));

var _Slider = _interopRequireDefault(__webpack_require__(35));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var lang = 'en';

if (document.documentElement && document.documentElement.lang) {
  lang = document.documentElement.lang; // The locale key for Norwegian differs between Cognos and Moment

  if (lang === 'no') {
    lang = 'nb';
  }
}

var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var rangeSliderFlag = _Slider["default"].rangeSliderFlag.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var MAX_NUMBER_DECIMAL = 17;

var getFormatted = function getFormatted(value, scale) {
  return Number(Number(value).toFixed(scale));
};

var RangeSlider = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(RangeSlider, _Component);

  function RangeSlider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      showFocusClass: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focus", function () {
      _this.numberInput.current && _this.numberInput.current.focus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setFocus", function () {
      _this.setState({
        showFocusClass: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setBlur", function () {
      _this.setState({
        showFocusClass: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_sliderContainerRef", function (node) {
      _this._sliderContainer = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getValidatedValues", function (values) {
      return values.map(function (v, i) {
        return isNaN(v) ? _this.state.values[i] : Number(v);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (values) {
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max,
          onChange = _this$props.onChange;

      var validatedValues = _this._getValidatedValues(values);

      _this.setState({
        min: Math.min(validatedValues[0], min),
        max: Math.max(validatedValues[1], max),
        values: validatedValues
      });

      onChange && onChange(validatedValues);
    });
    _this.numberInput = (0, _react.createRef)();
    return _this;
  }

  var _proto = RangeSlider.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this._getDerivedStateFromProps(this.props);
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.autoFocus) {
      this._focus();
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this._getDerivedStateFromProps(nextProps);
  };

  // The reason why we cannot use React one is that explore remount range slider every time prop change.
  _proto._getDerivedStateFromProps = function _getDerivedStateFromProps(props) {
    var min = props.min,
        max = props.max,
        propValues = props.values;
    var values = propValues && propValues.length === 2 ? propValues : [min, max];
    this.setState({
      values: values,
      min: Math.min(values[0], min),
      max: Math.max(values[1], max)
    });
  };

  _proto._getDir = function _getDir() {
    var dir = document.querySelector('[dir="rtl"]') ? 'right' : 'left';
    return dir;
  };

  _proto._toPercentage = function _toPercentage(value, min, max) {
    return Math.round((value - min) / (max - min) * 100);
  };

  _proto._renderHandleLabel = function _renderHandleLabel(props) {
    var dir = this._getDir();

    var value = props.value,
        index = props.index;
    var _this$state = this.state,
        min = _this$state.min,
        max = _this$state.max;
    var _this$props2 = this.props,
        labelFormatter = _this$props2.labelFormatter,
        scale = _this$props2.scale;

    var positionsOnTrackPercent = this._toPercentage(value, min, max);

    var handleLabelStyle = {};
    handleLabelStyle[dir] = positionsOnTrackPercent + "%";
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: index,
      style: handleLabelStyle,
      className: sliderClassName + "__handle_label " + rangeSliderFlag
    }, labelFormatter(value, scale));
  };

  _proto.render = function render() {
    var _cx,
        _this2 = this;

    var _this$props3 = this.props,
        id = _this$props3.id,
        step = _this$props3.step,
        disabled = _this$props3.disabled,
        light = _this$props3.light,
        _labelFormatter = _this$props3.labelFormatter,
        showHandleLabel = _this$props3.showHandleLabel,
        showInputBox = _this$props3.showInputBox,
        showBoundaryLabels = _this$props3.showBoundaryLabels,
        showTooltip = _this$props3.showTooltip,
        size = _this$props3.size,
        className = _this$props3.className,
        style = _this$props3.style,
        onInputComplete = _this$props3.onInputComplete,
        inverted = _this$props3.inverted,
        scale = _this$props3.scale,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["id", "step", "disabled", "light", "labelFormatter", "showHandleLabel", "showInputBox", "showBoundaryLabels", "showTooltip", "size", "className", "style", "onInputComplete", "inverted", "scale"]);
    var _this$state2 = this.state,
        min = _this$state2.min,
        max = _this$state2.max,
        values = _this$state2.values,
        showFocusClass = _this$state2.showFocusClass;
    var containerProps = {
      className: sliderClassName + " " + className,
      style: style
    };
    var sliderContainerProps = {
      className: (0, _utils.classnames)(sliderClassName + "__container", {
        focus: showFocusClass,
        disabled: disabled,
        handleLabelled: showHandleLabel,
        boundaryLabelled: showBoundaryLabels
      }),
      ref: this._sliderContainerRef,
      style: style
    };
    var boundaryLabelProps = {
      className: sliderClassName + "__boundary_label"
    };
    var sliderProps = (0, _extends2["default"])({}, sanitize(others, RangeSlider), {
      className: (0, _utils.classnames)(sliderClassName + "__container__input", rangeSliderFlag, inverted, (_cx = {}, _cx[size] = size, _cx)),
      allowCross: false,
      values: values,
      min: min,
      max: max,
      id: id,
      step: step,
      disabled: disabled,
      showTooltip: showTooltip,
      labelFormatter: function labelFormatter(value) {
        return _labelFormatter(value, scale);
      },
      onChange: this._onChange,
      onInputComplete: onInputComplete,
      tabIndex: -1,
      setFocus: this._setFocus,
      setBlur: this._setBlur,
      inverted: inverted
    });

    var renderLeftLabel = function renderLeftLabel() {
      return /*#__PURE__*/_react["default"].createElement("div", boundaryLabelProps, _labelFormatter(min, scale));
    };

    var renderRightLabel = function renderRightLabel() {
      return /*#__PURE__*/_react["default"].createElement("div", boundaryLabelProps, _labelFormatter(max, scale));
    };

    var renderInputBox = function renderInputBox() {
      return showInputBox ? /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        gutter: [0, 0, 5, 0]
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
        direction: "row"
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        grow: true
      }, /*#__PURE__*/_react["default"].createElement(_numberinput["default"], {
        scale: MAX_NUMBER_DECIMAL,
        disabled: disabled,
        light: light,
        step: step,
        max: values[1],
        fullWidth: true,
        value: values[0],
        onValueAccept: function onValueAccept(val) {
          return _this2._onChange([val, values[1]]);
        },
        locale: lang,
        ref: _this2.numberInput
      })), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        style: {
          width: '1rem'
        }
      }), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        grow: true
      }, /*#__PURE__*/_react["default"].createElement(_numberinput["default"], {
        scale: MAX_NUMBER_DECIMAL,
        disabled: disabled,
        light: light,
        step: step,
        min: values[0],
        fullWidth: true,
        value: values[1],
        onValueAccept: function onValueAccept(val) {
          return _this2._onChange([values[0], val]);
        },
        locale: lang
      })))) : null;
    };

    var renderBoundaryLabel = function renderBoundaryLabel() {
      return showInputBox && showBoundaryLabels ? /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        gutter: [1, 0, 0, 0]
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
        direction: "row"
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, renderLeftLabel()), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        grow: true
      }), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, renderRightLabel()))) : null;
    };

    return /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
      direction: "column"
    }, renderInputBox(), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", containerProps, showBoundaryLabels && !showInputBox ? renderLeftLabel() : null, /*#__PURE__*/_react["default"].createElement("div", sliderContainerProps, showHandleLabel && /*#__PURE__*/_react["default"].createElement("div", {
      className: sliderClassName + "__handle_label_container " + rangeSliderFlag
    }, values.map(function (value, index) {
      return _this2._renderHandleLabel({
        value: value,
        index: index
      });
    })), /*#__PURE__*/_react["default"].createElement(_Range["default"], sliderProps)), showBoundaryLabels && !showInputBox ? renderRightLabel() : null)), renderBoundaryLabel());
  };

  return RangeSlider;
}(_react.Component);

exports["default"] = RangeSlider;
(0, _defineProperty2["default"])(RangeSlider, "propTypes", {
  /** Minimum possible value for the slider */
  min: _propTypes["default"].number,

  /** Maximum possible value for the slider */
  max: _propTypes["default"].number,

  /** Function that gets called each time the slider is changed. It provides one parameter, which is the new value of the slider */
  onChange: _propTypes["default"].func,

  /** Function that gets called when user completes input */
  onInputComplete: _propTypes["default"].func,

  /** ID to give to the slider input */
  id: _propTypes["default"].string,

  /** Level of increment for each increase in the slider */
  step: _propTypes["default"].number,

  /** Disables the slider if passed */
  disabled: _propTypes["default"].bool,
  // Carbon light variant of the component
  light: _propTypes["default"].bool,

  /** Some function that is applied to the numeric values to format their labels for the slider. Should return a string */
  labelFormatter: _propTypes["default"].func,

  /** Option to show the label on the handle */
  showHandleLabel: _propTypes["default"].bool,

  /** Option to show the boundary input box */
  showInputBox: _propTypes["default"].bool,

  /** Option to show the min/max labels */
  showBoundaryLabels: _propTypes["default"].bool,

  /** Flag to display tooltip */
  showTooltip: _propTypes["default"].bool,

  /** Optional size for slider */
  size: _propTypes["default"].oneOf(['small', 'medium']),

  /** ClassName to be applied to the slider container */
  className: _propTypes["default"].string,

  /** Custom CSS styling */
  style: _propTypes["default"].object,

  /** Values in the case of range slider */
  values: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** Option to invert the range */
  inverted: _propTypes["default"].bool,

  /** Optional, scale for number format */
  scale: _propTypes["default"].number,

  /** Optional, auto focus on the first NumberInput */
  autoFocus: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(RangeSlider, "defaultProps", {
  size: 'medium',
  min: 0,
  max: 100,
  step: 1,
  scale: 3,
  labelFormatter: function labelFormatter(value, scale) {
    return getFormatted(value, scale).toLocaleString(lang);
  },
  className: '',
  style: {}
});

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Handle = _interopRequireDefault(__webpack_require__(494));

var _Track = _interopRequireDefault(__webpack_require__(495));

var _Slider = _interopRequireDefault(__webpack_require__(35));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var Range = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Range, _Component);

  function Range(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      trackDragging: false,
      handleDragging: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_moveClosestHandleToMouse", function (e) {
      if (_this.props.disabled) return;
      var _this$props = _this.props,
          values = _this$props.values,
          onChange = _this$props.onChange,
          min = _this$props.min;

      var _this$_getSliderPosit = _this._getSliderPosition(),
          left = _this$_getSliderPosit.left;

      var newValue = min + _this._calculateValueOffset(_this._getMouseOrTouchPosition(e) - left);

      var activeHandle = _this._getClosestHandleIndex(values, newValue);

      values[activeHandle] = newValue;

      _this._handleRefs[activeHandle].focus();

      onChange && onChange(values);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTrackDragStart", function (e) {
      if (_this.props.disabled) return;

      _utils.event.stopEvent(e);

      _this.setState({
        trackDragging: true
      });

      _this.prevTrackPos = _this._getMouseOrTouchPosition(e);

      if (_this._isTouchEvent(e)) {
        _this._trackRef.addEventListener('touchend', _this._onTrackDragDone);

        _this._trackRef.addEventListener('touchmove', _this._onTrackDragging);
      } else {
        _this._trackRef.addEventListener('mouseup', _this._moveClosestHandleToMouse);

        window.addEventListener('mouseup', _this._onTrackDragDone);
        window.addEventListener('mousemove', _this._onTrackDragging);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTrackKeyDown", function (e) {
      if (_this.props.disabled) return;

      var keyName = _utils.keyboardUtils.getKeyName(e);

      var TAB = _utils.keyboardUtils.keyNames.TAB;

      if (keyName === TAB) {
        return;
      }

      _utils.event.stopEvent(e);

      var _this$props2 = _this.props,
          values = _this$props2.values,
          onChange = _this$props2.onChange,
          onInputComplete = _this$props2.onInputComplete,
          step = _this$props2.step,
          min = _this$props2.min,
          max = _this$props2.max;

      var offset = _this._getKeyValueOffset(keyName, step);

      if (offset < 0 && values[0] > min || offset > 0 && values[1] < max) {
        onChange && onChange(values.map(function (value) {
          return _utils.mathUtils.decimalPlus(value, offset);
        }));
        onInputComplete && onInputComplete();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onHandleKeyDown", function (e, index) {
      if (_this.props.disabled) return;

      var keyName = _utils.keyboardUtils.getKeyName(e);

      var TAB = _utils.keyboardUtils.keyNames.TAB;

      if (keyName === TAB) {
        return;
      }

      _utils.event.stopEvent(e);

      var _this$props3 = _this.props,
          values = _this$props3.values,
          onChange = _this$props3.onChange,
          onInputComplete = _this$props3.onInputComplete,
          step = _this$props3.step,
          min = _this$props3.min,
          max = _this$props3.max;
      var copyValues = [].concat(values);

      var offset = _this._getKeyValueOffset(keyName, step);

      copyValues[index] = _utils.mathUtils.decimalPlus(copyValues[index], offset);

      if (min <= copyValues[0] && copyValues[0] <= copyValues[1] && copyValues[1] <= max) {
        onChange && onChange(copyValues);
        onInputComplete && onInputComplete();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTrackDragging", function (e) {
      if (_this.props.disabled) return;

      _utils.event.stopEvent(e);

      var _this$props4 = _this.props,
          values = _this$props4.values,
          onChange = _this$props4.onChange,
          min = _this$props4.min,
          max = _this$props4.max;

      var mousePos = _this._getMouseOrTouchPosition(e);

      var valueOffset = _this._calculateValueOffset(mousePos - _this.prevTrackPos); // Only update if we move mouse enough to have a change in value


      if (valueOffset !== 0) {
        _this._trackRef.removeEventListener('mouseup', _this._moveClosestHandleToMouse);

        _this._trackRef.focus();

        _this.prevTrackPos = mousePos;
        var postValues = values.map(function (v) {
          return _utils.mathUtils.decimalPlus(v, valueOffset);
        });

        if (postValues[0] >= min && postValues[1] <= max) {
          onChange && onChange(postValues, min, max);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onTrackDragDone", function () {
      _this._removeEventListener();

      _this.setState({
        trackDragging: false
      });

      delete _this.prevTrackPos;
      _this.props.onInputComplete && _this.props.onInputComplete();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onHandleDragStart", function (e, index) {
      if (_this.props.disabled) return;

      _utils.event.stopEvent(e);

      _this._handleRefs[index].focus();

      _this.setState({
        handleDragging: true
      });

      _this.activeHandleIndex = index;

      if (_this._isTouchEvent(e)) {
        _this._handleRefs[index].addEventListener('touchend', _this._onHandleDragDone);

        _this._handleRefs[index].addEventListener('touchmove', _this._onHandleDragging);
      } else {
        window.addEventListener('mouseup', _this._onHandleDragDone);
        window.addEventListener('mousemove', _this._onHandleDragging);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onHandleDragging", function (e) {
      if (_this.props.disabled) return;

      _utils.event.stopEvent(e);

      var _this$props5 = _this.props,
          values = _this$props5.values,
          onChange = _this$props5.onChange,
          min = _this$props5.min,
          max = _this$props5.max;

      var _this$_getSliderPosit2 = _this._getSliderPosition(),
          left = _this$_getSliderPosit2.left;

      var newValue = min + _this._calculateValueOffset(_this._getMouseOrTouchPosition(e) - left);

      if (_this.activeHandleIndex === 0) {
        values[0] = newValue > values[1] ? values[1] : newValue;
      } else {
        values[1] = newValue < values[0] ? values[0] : newValue;
      }

      onChange && onChange(_this._ensureValuesWithinRange(values, min, max));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onHandleDragDone", function () {
      _this._removeEventListener();

      _this.setState({
        handleDragging: false
      });

      delete _this.activeHandleIndex;
      _this.props.onInputComplete && _this.props.onInputComplete();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onRailClick", function (e) {
      if (_this.props.disabled) return;
      var _this$props6 = _this.props,
          values = _this$props6.values,
          min = _this$props6.min;

      var _this$_getSliderPosit3 = _this._getSliderPosition(),
          left = _this$_getSliderPosit3.left;

      var newValue = min + _this._calculateValueOffset(_this._getMouseOrTouchPosition(e) - left);

      var activeHandle = _this._getClosestHandleIndex(values, newValue);

      _this._moveClosestHandleToMouse(e);

      _this._onHandleDragStart(e, activeHandle);
    });
    _this._handleRefs = new Array(2);
    return _this;
  }

  var _proto = Range.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._removeEventListener();
  };

  _proto._removeEventListener = function _removeEventListener() {
    var _this2 = this;

    if (this.state.trackDragging) {
      window.removeEventListener('mousemove', this._onTrackDragging);
      window.removeEventListener('mouseup', this._onTrackDragDone);

      this._trackRef.removeEventListener('touchmove', this._onTrackDragging);

      this._trackRef.removeEventListener('touchend', this._onTrackDragDone);
    }

    if (this.state.handleDragging) {
      window.removeEventListener('mousemove', this._onHandleDragging);
      window.removeEventListener('mouseup', this._onHandleDragDone);

      this._handleRefs.forEach(function (handle) {
        handle.removeEventListener('touchmove', _this2._onHandleDragging);
        handle.removeEventListener('touchend', _this2._onHandleDragDone);
      });
    }

    this._trackRef.removeEventListener('mouseup', this._onTrackClick);
  };

  _proto._toPercentage = function _toPercentage(value, min, max) {
    return Math.round((value - min) / (max - min) * 100);
  };

  _proto._getMouseOrTouchPosition = function _getMouseOrTouchPosition(e) {
    return e.pageX || e.touches[0].pageX;
  };

  _proto._isTouchEvent = function _isTouchEvent(e) {
    return e.type === 'touchstart' || e.type === 'touchmove' || e.type === 'touchend';
  };

  _proto._ensureValuesWithinRange = function _ensureValuesWithinRange(values, min, max) {
    return values.map(function (v) {
      if (v < min) {
        return min;
      } else if (v > max) {
        return max;
      }

      return v;
    });
  };

  _proto._calculateValueOffset = function _calculateValueOffset(offset) {
    var _this$props7 = this.props,
        step = _this$props7.step,
        min = _this$props7.min,
        max = _this$props7.max;

    var _this$_getSliderPosit4 = this._getSliderPosition(),
        width = _this$_getSliderPosit4.width;

    var stepsTotal = Math.round((max - min) / step);
    var stepWidth = width / stepsTotal;
    return _utils.mathUtils.decimalMultiply(Math.round(offset / stepWidth), step);
  };

  _proto._getSliderPosition = function _getSliderPosition() {
    return {
      left: _utils.domUtils.computeLeftWith(this._sliderRef),
      width: _utils.domUtils.computeWidthOf(this._sliderRef)
    };
  };

  _proto._getKeyValueOffset = function _getKeyValueOffset(keyName, step) {
    var _keyboardUtils$keyNam = _utils.keyboardUtils.keyNames,
        LEFT = _keyboardUtils$keyNam.LEFT,
        RIGHT = _keyboardUtils$keyNam.RIGHT,
        UP = _keyboardUtils$keyNam.UP,
        DOWN = _keyboardUtils$keyNam.DOWN;

    if (keyName === LEFT || keyName === DOWN) {
      return -step;
    } else if (keyName === RIGHT || keyName === UP) {
      return step;
    }

    return 0;
  };

  _proto._getClosestHandleIndex = function _getClosestHandleIndex(values, newValue) {
    if (values[0] !== values[1]) {
      return Math.abs(newValue - values[0]) < Math.abs(newValue - values[1]) ? 0 : 1;
    }

    return newValue - values[0] > 0 ? 1 : 0;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props8 = this.props,
        values = _this$props8.values,
        min = _this$props8.min,
        max = _this$props8.max,
        className = _this$props8.className,
        onMouseEnter = _this$props8.onMouseEnter,
        onMouseLeave = _this$props8.onMouseLeave,
        showTooltip = _this$props8.showTooltip,
        labelFormatter = _this$props8.labelFormatter,
        setFocus = _this$props8.setFocus,
        setBlur = _this$props8.setBlur,
        inverted = _this$props8.inverted;
    var _this$state = this.state,
        trackDragging = _this$state.trackDragging,
        handleDragging = _this$state.handleDragging;
    var containerProps = {
      className: "" + className,
      ref: function ref(node) {
        _this3._sliderRef = node;
      },
      onMouseDown: this._onRailClick,
      // Need to stop touch event to avoid triggering mouse simulation events
      onTouchStart: function onTouchStart(e) {
        return _utils.event.stopEvent(e);
      },
      onTouchEnd: function onTouchEnd(e) {
        return _utils.event.stopEvent(e);
      }
    };
    var valuesAsPercent = values.map(function (value) {
      return _this3._toPercentage(value, min, max);
    });
    var railProps = {
      className: sliderClassName + "__rail" + (inverted ? ' is-inverted' : '')
    };
    var trackProps = {
      trackRef: function trackRef(node) {
        _this3._trackRef = node;
      },
      values: values,
      labelFormatter: labelFormatter,
      showTooltip: showTooltip && !this.state.handleDragging,
      style: {
        left: valuesAsPercent[0] + "%",
        width: valuesAsPercent[1] - valuesAsPercent[0] + "%"
      },
      onMouseDown: this._onTrackDragStart,
      onTouchStart: this._onTrackDragStart,
      onKeyDown: this._onTrackKeyDown,
      setFocus: setFocus,
      setBlur: setBlur,
      inverted: inverted
    };
    var handlesProps = valuesAsPercent.map(function (value, index) {
      return {
        className: (0, _utils.classnames)("handle-" + index),
        handleRef: function handleRef(node) {
          _this3._handleRefs[index] = node;
        },
        style: {
          left: value + "%"
        },
        value: values[index],
        showTooltip: showTooltip && !trackDragging && (!handleDragging || _this3.activeHandleIndex === index),
        labelFormatter: labelFormatter,
        onMouseDown: function onMouseDown(e) {
          return _this3._onHandleDragStart(e, index);
        },
        onTouchStart: function onTouchStart(e) {
          e.preventDefault();

          _this3._onHandleDragStart(e, index);
        },
        onKeyDown: function onKeyDown(e) {
          return _this3._onHandleKeyDown(e, index);
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        inverted: inverted
      };
    });
    var stepProps = {
      className: sliderClassName + "__step"
    };
    return /*#__PURE__*/_react["default"].createElement("div", containerProps, /*#__PURE__*/_react["default"].createElement("div", railProps), /*#__PURE__*/_react["default"].createElement("div", stepProps, /*#__PURE__*/_react["default"].createElement(_Track["default"], trackProps), /*#__PURE__*/_react["default"].createElement(_Handle["default"], handlesProps[0]), /*#__PURE__*/_react["default"].createElement(_Handle["default"], handlesProps[1])));
  };

  return Range;
}(_react.Component);

exports["default"] = Range;
(0, _defineProperty2["default"])(Range, "propTypes", {
  values: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  min: _propTypes["default"].number.isRequired,
  max: _propTypes["default"].number.isRequired,
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  step: _propTypes["default"].number.isRequired,
  showTooltip: _propTypes["default"].bool,
  labelFormatter: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onInputComplete: _propTypes["default"].func.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  setFocus: _propTypes["default"].func,
  setBlur: _propTypes["default"].func,
  inverted: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
});

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Slider = _interopRequireDefault(__webpack_require__(35));

var _TooltipWrapper = _interopRequireDefault(__webpack_require__(121));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var Handle = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Handle, _Component);

  function Handle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      showFocusClass: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.setState({
        showFocusClass: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function () {
      _this.setState({
        showFocusClass: false
      });
    });
    return _this;
  }

  var _proto = Handle.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        handleRef = _this$props.handleRef,
        value = _this$props.value,
        style = _this$props.style,
        onKeyDown = _this$props.onKeyDown,
        onMouseDown = _this$props.onMouseDown,
        onTouchStart = _this$props.onTouchStart,
        onTouchMove = _this$props.onTouchMove,
        onTouchEnd = _this$props.onTouchEnd,
        showTooltip = _this$props.showTooltip,
        labelFormatter = _this$props.labelFormatter,
        inverted = _this$props.inverted;
    var containerProps = {
      className: (0, _utils.classnames)(sliderClassName + "__handle", "" + className),
      ref: function ref(node) {
        _this2._containerRef = node;
      },
      style: style,
      showTooltip: showTooltip,
      orient: 'top',
      title: labelFormatter(value)
    };
    var handleProps = {
      className: (0, _utils.classnames)(sliderClassName + "__handle__input", {
        focus: this.state.showFocusClass,
        inverted: inverted
      }),
      ref: handleRef,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      onTouchMove: onTouchMove,
      onTouchEnd: onTouchEnd,
      onKeyDown: onKeyDown,
      tabIndex: 0,
      onKeyUp: this._onFocus,
      onBlur: this._onBlur
    };
    return /*#__PURE__*/_react["default"].createElement(_TooltipWrapper["default"], containerProps, /*#__PURE__*/_react["default"].createElement("div", handleProps));
  };

  return Handle;
}(_react.Component);

exports["default"] = Handle;
(0, _defineProperty2["default"])(Handle, "propTypes", {
  className: _propTypes["default"].string,
  handleRef: _propTypes["default"].func,
  value: _propTypes["default"].number.isRequired,
  style: _propTypes["default"].object,
  showTooltip: _propTypes["default"].bool,
  labelFormatter: _propTypes["default"].func.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  inverted: _propTypes["default"].bool
});

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Slider = _interopRequireDefault(__webpack_require__(35));

var _TooltipWrapper = _interopRequireDefault(__webpack_require__(121));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sliderClassName = _Slider["default"].sliderClassName.replace(/"/g, '');

var Track = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Track, _Component);

  function Track() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function () {
      _this.props.setFocus();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function () {
      _this.props.setBlur();
    });
    return _this;
  }

  var _proto = Track.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        trackRef = _this$props.trackRef,
        values = _this$props.values,
        style = _this$props.style,
        onTouchStart = _this$props.onTouchStart,
        onTouchMove = _this$props.onTouchMove,
        onTouchEnd = _this$props.onTouchEnd,
        onKeyDown = _this$props.onKeyDown,
        onMouseDown = _this$props.onMouseDown,
        showTooltip = _this$props.showTooltip,
        labelFormatter = _this$props.labelFormatter,
        inverted = _this$props.inverted;
    var containerProps = {
      className: (0, _utils.classnames)(sliderClassName + "__track", "" + className),
      ref: function ref(node) {
        _this2._containerRef = node;
      },
      style: style,
      showTooltip: showTooltip,
      orient: 'top',
      title: labelFormatter(values[0]) + " - " + labelFormatter(values[1])
    };
    var trackProps = {
      className: sliderClassName + "__track__input" + (inverted ? ' is-inverted' : ''),
      ref: trackRef,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      onTouchMove: onTouchMove,
      onTouchEnd: onTouchEnd,
      onKeyDown: onKeyDown,
      tabIndex: 0,
      onKeyUp: this._onFocus,
      onBlur: this._onBlur
    };
    return /*#__PURE__*/_react["default"].createElement(_TooltipWrapper["default"], containerProps, /*#__PURE__*/_react["default"].createElement("div", trackProps));
  };

  return Track;
}(_react.Component);

exports["default"] = Track;
(0, _defineProperty2["default"])(Track, "propTypes", {
  className: _propTypes["default"].string,
  trackRef: _propTypes["default"].func,
  values: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  style: _propTypes["default"].object,
  showTooltip: _propTypes["default"].bool,
  labelFormatter: _propTypes["default"].func.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  setFocus: _propTypes["default"].func,
  setBlur: _propTypes["default"].func,
  inverted: _propTypes["default"].bool
});

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__50__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[488,0]]]);
});